import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/da/onlineRate/getpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/da/onlineRate/getdetail/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getClientPage = (params, urlParams) => {
  return axios.request({
    url: '/da/onlineRate/getclientpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const exportExcel = (params, urlParams) => {
  return axios.request({
    url: '/da/onlineRate/exportexcel' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const attentionGetPage = (params, urlParams) => {
  return axios.request({
    url: '/da/onlineRate/attentionpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

